import { useTranslate as useTolgeeHook } from '@tolgee/vue'
import { getCurrentInstance } from 'vue'
import { useNuxtApp } from '#imports'

export const useTranslate = () => {
  if (getCurrentInstance()) {
    const { t: originalT } = useTolgeeHook()
    return {
      // biome-ignore lint/suspicious/noExplicitAny: Tolgee expects any[]
      t: (key: string, ...args: any[]) => originalT.value(key, ...args),
    }
  }

  const { $tolgee } = useNuxtApp()
  return {
    // biome-ignore lint/suspicious/noExplicitAny: Tolgee expects any[]
    t: (key: string, ...args: any[]) => $tolgee.t(key, ...args),
  }
}
